import { FilterType } from "../../types/nlsCommon";
import { extractDate } from "../../common/utils";
import { BlogPostType } from "@nls-2022/nls-api";

export const filterByPublishedStatus = (
  blogPosts: Array<BlogPostType> | undefined,
  publishedStatus: boolean | null = null
) =>
  blogPosts!.filter((blogPost) =>
    publishedStatus === true
      ? blogPost.IsPublished === true
      : publishedStatus === false
      ? blogPost.IsPublished === false
      : true
  );

export const filterByCategory = (
  blogPosts: Array<BlogPostType> | undefined,
  category: string
) => blogPosts!.filter((blogPost) => blogPost.Categories.includes(category));

export const filterByCategories = (
  blogPosts: Array<BlogPostType> | undefined,
  categories: Array<string>
) =>
  blogPosts!.filter((blogPost) =>
    blogPost.Categories.some((category) => categories.includes(category))
  );

//export enum FilterType {
//  LT,
//  EQ,
//  GT,
//  LTE,
//  GTE,
//}
//const extractDate = (dateStr: string) => dateStr.split("T")[0];

export const filterByPubDate = (
  blogPosts: Array<BlogPostType> | undefined,
  pubDate: string,
  filter: FilterType
) =>
  blogPosts!.filter(
    (blogPost) =>
      (filter === FilterType.LT && extractDate(blogPost.PubDate) < pubDate) ||
      (filter === FilterType.EQ && extractDate(blogPost.PubDate) === pubDate) ||
      (filter === FilterType.GT && extractDate(blogPost.PubDate) > pubDate) ||
      (filter === FilterType.LTE && extractDate(blogPost.PubDate) <= pubDate) ||
      (filter === FilterType.GTE && extractDate(blogPost.PubDate) >= pubDate)
  );
